import { _post } from "../Api";
import { toast } from "react-toastify";

export function getFolders(merchantIds) {
  return _post(`/fm/getFolders`, { merchantIds: merchantIds })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getFiles(merchantIds, collectionName) {
  return _post(`/fm/getFiles`, { merchantIds: merchantIds, collectionName: collectionName })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getFile(merchantId, collectionName, mediaName) {
  return _post(`/fm/getFile`, { merchantId, collectionName, mediaName })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function uploadFile(merchantId, collectionName, files) {
  let formData = new FormData();
  formData.set("merchantId", merchantId);
  formData.set("collectionName", collectionName);
  for (let i = 0; i < files.length; i++) {
    formData.append("files[]", files[i]);
  }

  return _post(`/fm/uploadFiles`, formData, "multipart/form-data")
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function deleteFile(merchantId, collectionName, mediaName) {
  return _post(`/fm/deleteFile`, { merchantId, collectionName, mediaName })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function createFolder(merchantId, collectionName) {
  return _post(`/fm/createFolder`, { merchantId, collectionName })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}
